<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <x-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-my-auto tw-text-center sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Deny Rx Authorization</h3>
        </div>
      </div>
      <div class="tw-mt-8">
        <base-form ref="form" @submit.prevent class="tw-w-full">
          <base-textarea label="Comment" placeholder="Please enter a reson for denying this authorization." v-model="comment" required />
        </base-form>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="denyRxAuth" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Deny</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="gray">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-activity-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import XIcon from "@/assets/svgs/x-icon.svg";

export default {
  components: {
    InlineError,
    XIcon,
  },
  name: "DenyRxAuth",
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      todoItemId: null,
      comment: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    show(todoItemId) {
      this.todoItemId = todoItemId;
      this.comment = null;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.todoItemId = null;
      this.comment = null;
    },
    denyRxAuth() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/todo/${this.todoItemId}/deny`, { comment: this.comment })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Authorization Denied",
            message: `Your denial was submitted. Thank you.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error submitting denial`;
          this.errorMessage = "Sorry, we had trouble submitting this denial. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
